import Dexie from "dexie"

export const DB = new Dexie("databse")

DB.version(1).stores({
    history: "++id,waste_type,date",
})

DB.open()
